import templateUrl from './root.html';

export default {
  templateUrl
};



// WEBPACK FOOTER //
// ./root.component.js